const maskClip = {
    name: "mask-clip",
    path: "mask-clip",
    title: "mask-clip",
    description: "Utilities for controlling the CSS mask-clip property.",
    value: {
        "mask-clip": {
            "mask-clip-content": "content-box",
            "mask-clip-border": "border-box",
            "mask-clip-padding": "padding-box",
            "mask-clip-filled": "fill-box",
            "mask-clip-stroke": "stroke-box",
            "mask-clip-view-box": "view-box",
            "mask-no-clip": "no-clip"
        }
    },
    exampleData: [
        {
            "title": "mask-clip-border, mask-clip-padding, mask-clip-content",
            "description": "to control the bounding box of an element's mask:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-6 !bg-none !border-0 pt-10 py-5 !mt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "-inset-2 absolute max-w-[110%]",
                        "text": "mask-clip-border",
                        "containerClass": "relative mask-clip-border p-2 mask-size-cover size-36 mx-auto mask-image-[url(https://cdn.pixabay.com/photo/2023/04/03/07/34/circle-7896189_1280.png)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "-inset-2 absolute max-w-[110%]",
                        "text": "mask-clip-content",
                        "containerClass": "relative mask-clip-content p-2 mask-size-cover size-36 mx-auto mask-image-[url(https://cdn.pixabay.com/photo/2023/04/03/07/34/circle-7896189_1280.png)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "-inset-2 absolute max-w-[110%]",
                        "text": "mask-clip-padding",
                        "containerClass": "relative mask-clip-padding p-2 mask-size-cover size-36 mx-auto mask-image-[url(https://cdn.pixabay.com/photo/2023/04/03/07/34/circle-7896189_1280.png)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "-inset-2 absolute max-w-[110%]",
                        "text": "mask-clip-filled",
                        "containerClass": "relative mask-clip-filled p-2 mask-size-cover size-36 mx-auto mask-image-[url(https://cdn.pixabay.com/photo/2023/04/03/07/34/circle-7896189_1280.png)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    
                ],
                "className": "relative",
                "code": `<div class="mask-clip-border mask-[url(/img/circle.png)]  ..."></div>
<div class="mask-clip-padding mask-[url(/img/circle.png)]  ..."></div>
<div class="mask-clip-content mask-[url(/img/circle.png)]  ..."></div>
<div class="mask-clip-filled mask-[url(/img/circle.png)]  ..."></div>`
            }
        }
    ]
};

export default maskClip;